const isNativeApp = (device = '') => device.indexOf('-app') !== -1;

export default isNativeApp;
